import { useInfiniteQuery } from "@tanstack/react-query";
import { getMessages } from "../actions/getMessages.actions";
import { useMemo } from "react";
import { getMessageQueryKey } from "../utils/messageConversation.utils";

export const useMessagesQuery = ({ pageSize = 50, receiver, companyId, search = "", enabled = true }) => {
  const queryKey = getMessageQueryKey(receiver, companyId, search);

  const queryOptions = useMemo(
    () => ({
      queryKey,
      queryFn: async ({ pageParam = 1 }) => {
        const res = await getMessages({
          page: pageParam,
          pageSize,
          order: "DESC",
          receiveIdentifier: receiver.id ?? receiver.uid,
          receiverType: receiver.type,
          search,
        });
        return res?.data;
      },
      getNextPageParam: (lastPage) => {
        const page = Number(lastPage?.page);
        const total = Number(lastPage?.totalPages);
        if (!page || !total || page >= total) return undefined;
        return page + 1;
      },
      initialPageParam: 1,
      refetchOnWindowFocus: false,
      refetchOnMount: false,
      refetchOnReconnect: false,
      staleTime: 0,
      gcTime: 0,
      enabled: enabled && Boolean(receiver && (receiver.id || receiver.uid)),
    }),
    [pageSize, receiver?.id, receiver?.uid, receiver?.type, companyId, search, enabled, queryKey]
  );

  const messagesQuery = useInfiniteQuery(queryOptions);

  return { messagesQuery };
};
